module.exports = __webpack_public_path__ + "img/eur.6835cf83.svg";